export default function EduTestingAppsSettings() {
  return (
    <div style={{ color: "#475467", lineHeight: 1.6 }}>
      Testing app availability is managed from the main page. District-level enablement happens inside each EDU organization.
    </div>
  );
}
